import { BaseModel } from './base-model';
import { Organization } from './organization';
import { UserRole } from './user-role';
import { MarketLevel } from './market-level';
import { Market } from './market';
import { UserMarket } from './user-market';
import { Distributor } from './distributor';
import { Customer } from './customer';
import { ProductLine } from './product-line';
import { UserProductLine } from './user-product-line';
import { ProductBrand } from './product-brand';
import { UserProductBrand } from './user-product-brand';
import { UserBillingOrganization } from './UserBillingOrganization';
import {PaymentTypeEnum} from '../enums/new-payment-type-enum';
import {Poi} from './poi';
import {Project} from './project';

export class User extends BaseModel {
    Organization: Organization;
    UserType: string;
    UserName: string;
    UserCode: string;
    SecondaryCode: string;
    UserRole: UserRole;
    Designation: string;
    Email: string;
    Mobile: string;
    Password: string;
    JoiningDate: string;
    Image: string;
    ImageData: string;
    ImageType: string;
    MarketLevelHierarchy: MarketLevel[];
    MarketList: Market[];
    UserMarketList: UserMarket[];
    Distributor: Distributor;
    Customer: Customer;
    ProductLineList: ProductLine[];
    UserProductLineList: UserProductLine[];
    ProductBrandList: ProductBrand[];
    UserProductBrandList: UserProductBrand[];
    UserBillingOrgList: UserBillingOrganization[];
    AttendanceLat = 0.0;
    AttendanceLon = 0.0;
    ChangePassword: boolean;
    PaymentType: PaymentTypeEnum;
    PaymentNumber: string;
    JobSite: Poi;
    Project: Project;

    constructor( pId?: number ) {
        super();
        if ( pId ) {
            this.Id = pId;
        }
    }
}
